const initialState = {
    responseAncillariesList: [],
    responseAncillary: {},
    // responseHashExportAncillaries: [],
    // responseCheckReportAncillaries: [],
    // errorHashExportAncillaries: false,
    // errorCheckReportAncillaries: false
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "ANCILLARIES_RESPONSE_LIST":
            if (action.value.detail !== undefined)
                newState.responseAncillariesList = []
            else
                newState.responseAncillariesList = action.value;

            newState.responseAncillary = {}
            break;

        case "GET_ANCILLARY":
            newState.responseAncillary = {};
            break;

        case "ANCILLARY_RESPONSE":
            newState.responseAncillary = action.value;
            break;

        case "ANCILLARY_RESPONSE_ERROR":
            newState.responseAncillary = action.value;
            if (!newState.responseAncillary.detail) {
                newState.responseAncillary.detail = {};
            }
            break;

        // case 'HASH_EXPORT_ANCILLARIES_RESPONSE':
        //     newState.responseHashExportAncillaries = action.value;
        //     if (action.value.status !== "OK") {
        //         newState.errorHashExportAncillaries = true;
        //     } else {
        //         newState.errorHashExportAncillaries = false;
        //     }
        //     break;

        // case 'REPORT_EXPORT_ANCILLARIES_RESPONSE':
        //     newState.responseCheckReportAncillaries = action.value;
        //     if (action.value.status !== "OK") {
        //         newState.errorCheckReportAncillaries = true;
        //     } else {
        //         newState.errorCheckReportAncillaries = false;
        //     }
        //     break;

        default:
            return newState;
    }

    return newState;
};

export default reducer;
